import {
  HOMEPAGE_RECRUIT_FETCHING,
  HOMEPAGE_RECRUIT_FAILED,
  HOMEPAGE_RECRUIT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case HOMEPAGE_RECRUIT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case HOMEPAGE_RECRUIT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case HOMEPAGE_RECRUIT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
